<template>
  <div>
    <div ref="brandConcept" style="padding-bottom: 210px"></div>
    <div style="position: fixed;top: 0;z-index: 999999;width: 100%">
      <div class="middle" v-if="show" :style="show?'touch-action: none':''">
        <div class="father_box" v-for="(item,index) in titleList" :key="index" @click="selectMenu(item)">
          <div class="choose">
            <span :class="menuIndex == index ? 'chooseIndex active' : 'chooseIndex'" >{{ item.title }}</span>
            <div class="border_" v-if="menuIndex == index"></div>
          </div>

        </div>
      </div>
      <div class="box" >
        <div class="left_image" @click="goToHome">
          <img src="/status/logoytx.png">
        </div>
        <div class="right_text">
          全国厂家热线：400-022-9558
          <img v-if="!show" @click="show = !show" src="/status/menu-toggle-a.png">
          <img v-else @click="show = !show" src="/status/menu-toggle-b.png">
        </div>
      </div>
    </div>
<!--    <el-carousel  height="400px" arrow="never" v-if="menuIndex != 5 && menuIndex != 4 && menuIndex != -1">-->
<!--      <el-carousel-item v-for="(item,index) in swiperList" :key="index">-->
<!--        <div class="swiper_list">-->
<!--          <div class="swiper_text">-->
<!--            成为大健康行业佼佼者-->
<!--          </div>-->
<!--          <div class="swiper_title">-->
<!--            Becoming a leader in the big health industry-->
<!--          </div>-->
<!--          <div class="swiper_title2">-->
<!--            在国家“互联网+医疗健康”制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展-->
<!--          </div>-->
<!--        </div>-->
<!--        <img :src="item" alt="">-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->
<!--    <el-carousel height="600px" v-if="menuIndex != 5 && menuIndex != 4 && menuIndex != -1">-->
<!--      <el-carousel-item v-for="(item,index) in swiperNewList" :key="index">-->
<!--        <div :class="item.left ? 'swiper_new_list':'swiper_new_list right'">-->
<!--          <div class="swiper_text">-->
<!--            {{item.text}}-->
<!--          </div>-->
<!--          <div class="swiper_new_title" v-html="item.title">-->
<!--          </div>-->
<!--          <div class="swiper_new_title2">-->
<!--            了解更多-->
<!--          </div>-->
<!--        </div>-->
<!--        <img :src="item.img" alt="">-->
<!--      </el-carousel-item>-->
<!--    </el-carousel>-->
    <!-- 轮播图开始 -->
        <el-carousel arrow="always" :autoplay="false" height="800px" v-if="menuIndex != 1 &&menuIndex != 6 && menuIndex != 5 && menuIndex != -1">
          <el-carousel-item>
            <div class="swiper_side_content swiper_side_first">
              <div class="website_wrapper side_content_container">
                <div class="side_module">
                  <div class="module_title">智慧医疗
                  <div>引领未来</div></div>
                  <div class="module_en_title">leading the future</div>
                  <div class="module_message">
                    <div>当医疗与科技的力量相互交融，创新便呼之欲出当我们不断地寻求突破，探索未知，将为人类健康事业带来全新的可能和机遇</div>
                  </div>
                  <div class="module_more">查看更多</div>
                </div>
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="home_banner">
              <div class="swiper_side_content swiper_side_second">
                <div class="website_wrapper side_content_container">
                  <div class="side_module_second">
                    <div class="side_second_title">成为大健康行业佼佼者</div>
                    <div class="side_second_en_title">Becoming a leader in the big health industry</div>
                    <div class="side_second_msg">在国家“互联网+医疗健康”制度的指引下,持续推动技术创新和产品升级，秉承“用科技服务人类健康”的理念，推动世界医疗健康事业发展</div>
                    <div class="side_second_bg"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>


        </el-carousel>

    <!-- 轮播图结束 -->
  </div>
</template>

<script>
import  {swiperList} from '@/views/mock'
export default {
  name: "header_menu_phone",
  data() {
    return {
      show:false,
      swiperList:swiperList,
      swiperNewList:[
        {
          img:'/newIndex/swiper1.jpg',
          text:'专业行业软件系统研发',
          title:'致力于为您提供专业的软件服务<br/>为品牌和商家提供从流量到变现的一站式解决方案',
          left:true,
        },
        {
          img:'/newIndex/swiper2.jpg',
          text:'专业行业软件系统研发',
          title:'致力于为您提供专业的软件服务<br/>为品牌和商家提供从流量到变现的一站式解决方案',
          left:false,
        }
      ],
      menuIndex: 0,
      titleList: [
        {title: '首页', url: 'phone'},
        {title: '智慧导诊', url: 'intelligentGuidancePhone'},
        {title: '品牌理念', url: 'brandConceptPhone'},
        {title: '企业资讯', url: 'enterpriseInformationPhone'},
        {title: '商务合作', url: 'businessCooperationPhone'},
        {title: '核心产品', url: 'coreProductPhone'},
        {title: '人才招聘', url: 'talentRecruitmentPhone'},
        {title: '联系我们', url: 'contactUsPhone'},
      ],
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        console.log(val,'val')
        let index;
        if (val.name == 'phone') {
          index = 0
        } else if (val.name == 'intelligentGuidancePhone') {
          index = 1
        }else if (val.name == 'brandConceptPhone') {
          index = 2
        } else if (val.name == 'enterpriseInformationPhone' || val.name == 'enterpriseInformationInfoPhone') {
          index = 3
        } else if (val.name == 'businessCooperationPhone') {
          index = 4
        } else if (val.name == 'coreProductPhone' || val.name == 'coreProductInfoPhone') {
          index = 5
        }else if (val.name == 'talentRecruitmentPhone' || val.name == 'recruitInfoPhone') {
          index = 6
        }else if (val.name == 'contactUsPhone') {
          index = 7
        }else {
          index = -1
        }
        this.menuIndex = index
        if(!val.query.slide){

        }
        this.$refs.brandConcept.scrollIntoView({ behavior: 'smooth' });
      },
      deep: true
    }
  },
  mounted(){

  },
  methods: {
    goToHome(){
      this.$router.push({name: 'phone'});
    },
    selectMenu(item, index) {
      let params = {};
      if(item.url == 'coreProductPhone'){
        params = {fid:0}
      }else {
        params = {}
      }
      this.$router.push({name: item.url,query:params});
      this.show = false
    }
  }
}
</script>

<style scoped lang="scss">
.middle {
  position: absolute;
  border-top: 1px solid white;
  background: #0D68F2;
  width: 100%;
  color: white;
  top: 210px;
  height: calc(100vh - 210px);
  z-index: 999;
  font-weight: 600;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  font-size: 60px;
  .father_box{
    border-bottom: 2px solid white;
    margin: 0 60px 0 60px;
    padding: 55px 0 55px 0;
  }
  .choose {

  }
  .chooseIndex:hover {
    //color: #076691;
    cursor: pointer;
    color: black;
  }
  .chooseIndex{

  }
  .border_ {
    //background: #076691;
    background: black;
    //border: 1px solid #076691;
    //border: 1px solid black;
    //margin-top: 2px;
  }

  .active {
    //color: #076691;
    color: black;
  }
}
.box {
  //background-color: white;
  display: flex;
  background: #0D68F2;
  align-items: center;
  justify-content: space-between;
  padding: 40px 50px;
  .left_image{
    img{
      width: 400px;
    }
  }
  .right_text{
    font-size: 48px;
    color: white;
    display: flex;
    align-items: center;
    img{
      width: 80px;
      margin-left: 20px;
    }
  }


}
//.el-carousel__item{
//  img{
//    width: 100%;
//    height: 430px;
//  }
//
//}
//::v-deep .el-carousel__button{
//  width: 10px;
//  height: 10px;
//  border-radius: 100%;
//  background: rgb(122,179,239);
//}
//.swiper_list{
//  border-radius: 14px;
//  padding: 18px;
//  position: absolute;
//  top: 20%;
//  right: 50%;
//  background: rgb(241,240,239);
//  .swiper_text{
//    font-size: 28px;
//    color: #02b2b5;
//    font-weight: 700;
//  }
//  .swiper_title{
//    color: #7c7c7c;
//    font-size: 22px;
//    margin: 20px 0 20px 0;
//  }
//  .swiper_title2{
//    font-size: 14px;
//    color: #888;
//    width: 500px;
//    margin-top: 10px;
//  }
//}
.el-carousel__item{
  img{
    width: 100%;
    height: 600px;
  }

}
.swiper_new_list{
  position: absolute;
  top: 30%;
  left: 15%;
  .swiper_text{
    font-size: 47px;
    color: rgb(0, 0, 0);
  }
  .swiper_new_title{
    font-size: 18px;
    color: rgb(102, 102, 102);
    margin-top: 30px;
    line-height: 30px;
  }
  .swiper_new_title2{
    background: rgba(22, 100, 255, 1);
    color: white;
    width: 150px;
    height: 50px;
    line-height: 50px;
    margin-top: 40px;
    border-radius: 4px;
    text-align: center;
  }
}
.right{
  left: 56%;
}









.swiper_side_first {
  background: url('/homeSwiper/swiper1.png');
}

.swiper_side_second {
  background: url('/homeSwiper/swiper2.png');
}

.swiper_side_content {
  position: relative;
  height: 800px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  cursor: default;

  .side_content_container {
    height: 800px;
    position: relative;

    .side_module {
      position: absolute;
      top: 100px;
      left: 140px;

      height: auto;
      color: #ffffff;

      .module_title {
        width: 900px;
        font: 80px '幼圆';
        font-weight: bold;
      }

      .module_en_title {
        font: 50px '微软雅黑';
        font-weight: 700;
        margin-top: 20px;
      }

      .module_message {
        width: 1400px;
        //height: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-size: 44px;
        margin: 35px 0;
      }

      .module_more {
        margin-top: 60px;
        color: #02b2b5;
        background: #ffffff;
        width: 300px;
        font-size: 34px;
        height: 80px;
        text-align: center;
        line-height: 80px;
        cursor: pointer;
      }
    }

    .side_module_second {
      position: absolute;
      top: 120px;
      left: 140px;
      width: 900px;
      height: auto;
      font-family: '微软雅黑';
      padding: 30px;
      background: linear-gradient(to right, rgb(255, 255, 255,0.8) , rgba(225, 225, 216,0.1));
      border-radius: 20px;
      .side_second_title {
        font-size: 80px;
        color: #02b2b5;
        font-weight: 700;
      }

      .side_second_en_title {
        color: #7c7c7c;
        font-size: 40px;
        margin: 30px 0 10px 0;
      }

      .side_second_msg {
        font-size: 40px;
        color: #888888;
        width: 760px;
        margin-top: 40px;
      }

      .side_second_bg {
        position: absolute;
        top: 300px;
        left: 740px;
        width: 343px;
        height: 289px;
        background: url('/homeSwiper/side2.png') 100% 100%;
      }
    }
  }
}
::v-deep .el-carousel__button{
  width: 40px !important;
  height: 40px;
  border-radius: 100px !important;
  margin-left: 20px;
  margin-bottom: 20px;
}
::v-deep .el-carousel__arrow{
  width: 90px;
  height: 90px;
  i{
    font-size: 60px;
  }
}
</style>
